import { NavLink } from 'react-router-dom';

function SiteNav() {
  return (
    <nav className="Site-nav" aria-label="Main">
      <NavLink
        to="/"
        className={({ isActive }) =>
          isActive ? 'Site-nav-link Site-nav-link--active' : 'Site-nav-link'
        }
        end
      >
        Home
      </NavLink>
      <NavLink
        to="/development-site"
        className={({ isActive }) =>
          isActive ? 'Site-nav-link Site-nav-link--active' : 'Site-nav-link'
        }
      >
        First builds
      </NavLink>
      <NavLink
        to="/build-progress"
        className={({ isActive }) =>
          isActive ? 'Site-nav-link Site-nav-link--active' : 'Site-nav-link'
        }
      >
        Build progress
      </NavLink>
      <NavLink
        to="/example-work"
        className={({ isActive }) =>
          isActive ? 'Site-nav-link Site-nav-link--active' : 'Site-nav-link'
        }
      >
        Example work
      </NavLink>
    </nav>
  );
}

export default SiteNav;
